export default "__VITE_ASSET__CCd7jwVJ__"